import {
	login as Login,
	logout as Logout,
	getLoggedProfile as GetLoggedProfile,
	getListAddressOfUser as GetListAddressOfUser,
} from "../model/profile";

export function login(username, password) {
	return (dispatch) => {
		return dispatch({
			type: "LOG_IN",
			payload: Login(username, password),
		}).then(() => dispatch(getLoggedProfile()));
	};
}

export function logout() {
	return (dispatch) => {
		return dispatch({
			type: "LOG_OUT",
			payload: Logout(),
		});
	};
}

export function getLoggedProfile() {
	return {
		type: "GET_LOGGED_PROFILE",
		payload: GetLoggedProfile(),
	};
}

export function getListAddress(pos, ver) {
	return {
		type: "GET_LIST_ADDRESS",
		payload: GetListAddressOfUser(pos, ver),
	};
}
